import { isLight } from '@/utils/color-generator';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useThemeStore = defineStore('theme', () => {
  /** Organization/brand primary before dark-mode lightening. */
  const basePrimary = ref<string>('#4D11F6');
  /** Currently applied primary (may be lightened in dark mode). */
  const currentPrimary = ref<string>('#4D11F6');

  const primaryIsLight = computed(() => {
    return currentPrimary.value && isLight(currentPrimary.value);
  });

  return {
    basePrimary,
    currentPrimary,
    primaryIsLight,
  };
});
